import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const Wrapper = Styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Column = Styled.div`
  flex: 1;
  padding: 32px 30px;

  .nui-block:not(:first-child) {
    margin-top: -20px;
  }

  .nui-block:last-child {
    margin-bottom: 0px;
  }

  &.minimal {
    padding: 0;
  }

  &.full {
    flex-basis: 100%;
    padding-bottom: 0;
  }

  & + .full {
    padding-bottom: 32px;
    padding-top: 0;
  }

  &:not(.full) + div:not(.full) {
    padding-left: 0;
  }
`;

/**
 * @param {string} className
 */
const StyledNekoWrapper = props => {
  return (
    <Wrapper>
      { props.children }
    </Wrapper>
  );
};

const StyledNekoColumn = props => {
  const { full, minimal, ...rest } = props;
  let className = full ? 'full' : '';
  className += minimal ? ' minimal' : '';
  return (
    <Column className={className} {...rest}>{props.children}</Column>
  );
};

const NekoWrapper = (props) => {
  return (<StyledNekoWrapper {...props} />);
};

const NekoColumn = (props) => {
  return (<StyledNekoColumn {...props} />);
};

NekoWrapper.propTypes = {
};
NekoWrapper.defaultProps = {
};

NekoColumn.propTypes = {
  full: PropTypes.any
};
NekoColumn.defaultProps = {
  full: undefined
};

export { NekoWrapper, NekoColumn };
